<div class="side-bar-holder" *ngIf="isVisible">
  <div class="logo-holder" [class.loading]="isLoading$ | async">
    <a routerLink="/">
      <img src="assets/images/logo.png" alt="" title="" class="logo" />
      <img src="assets/app-loading.gif" alt="" title="" class="loading-logo" />
    </a>
  </div>
  <div class="side-menu-holder">
    <ul class="side-menu">
      <li *ngxPermissionsOnly="['canSeeCalendar']" routerLinkActive="active">
        <a routerLink="/calendar/multi">
          <span class="icon fal fa-calendar-alt"></span>
          Calendar
        </a>
        <ul class="side-submenu">
          <li *ngxPermissionsOnly="['canSeeMultiCalendar']" routerLinkActive="active">
            <a routerLink="/calendar/multi" title="Multi Calendar">
              <i class="fas fa-arrow-right active-icon"></i>
              Multi
            </a>
          </li>
          <li *ngxPermissionsOnly="['canSeeStandardCalendar']" routerLinkActive="active">
            <a routerLink="/calendar/standard" title="Standard Calendar">
              <i class="fas fa-arrow-right active-icon"></i>
              Standard
            </a>
          </li>
          <li *ngxPermissionsOnly="['canSeePlanningCalendar']" routerLinkActive="active">
            <a routerLink="/calendar/planning" title="Planning Calendar">
              <i class="fas fa-arrow-right active-icon"></i>
              Planning
            </a>
          </li>
          <li *ngxPermissionsOnly="['canSeeAgenda']" routerLinkActive="active">
            <a routerLink="/calendar/agenda" title="Agenda">
              <i class="fas fa-arrow-right active-icon"></i>
              Agenda
            </a>
          </li>
          <li *ngxPermissionsOnly="['canSeeHold']" routerLinkActive="active">
            <a routerLink="/calendar/hold" title="Hold Events">
              <i class="fas fa-arrow-right active-icon"></i>
              Hold Events
            </a>
          </li>
        </ul>
      </li>
      <li *ngxPermissionsOnly="['canSeeGuests']" routerLinkActive="active">
        <a routerLink="/guests">
          <span class="icon fal fa-users"></span>
          Guests
        </a>
      </li>
      <li *ngxPermissionsOnly="['canSeeInquiries']" routerLinkActive="active">
        <a routerLink="/inquiries/inbox">
          <span class="icon fal fa-file-edit"></span>
          Inquiries
        </a>
        <ul class="side-submenu">
          <li routerLinkActive="active">
            <a routerLink="/inquiries/inbox" title="Inbox">
              <i class="fas fa-arrow-right active-icon"></i>
              Inbox
            </a>
          </li>
          <li routerLinkActive="active">
            <a routerLink="/inquiries/list" title="List">
              <i class="fas fa-arrow-right active-icon"></i>
              List
            </a>
          </li>
          <li routerLinkActive="active">
            <a routerLink="/inquiries/message-feed" title="Messages">
              <i class="fas fa-arrow-right active-icon"></i>
              Messages
            </a>
          </li>
        </ul>
      </li>
      <li *ngxPermissionsOnly="['canSeeInvoices']" routerLinkActive="active">
        <a routerLink="/invoices/list">
          <span class="icon fal fa-file-alt"></span>
          Invoices
        </a>
        <ul class="side-submenu">
          <li routerLinkActive="active">
            <a routerLink="/invoices/list" title="List">
              <i class="fas fa-arrow-right active-icon"></i>
              List
            </a>
          </li>
          <li routerLinkActive="active">
            <a routerLink="/invoices/templates" title="Templates">
              <i class="fas fa-arrow-right active-icon"></i>
              Templates
            </a>
          </li>
          <li routerLinkActive="active">
            <a routerLink="/invoices/rules" title="Rules">
              <i class="fas fa-arrow-right active-icon"></i>
              Rules
            </a>
          </li>
        </ul>
      </li>
      <li class="acm-feature-item" *ngIf="!isOwner">
        <a
          [href]="acmFeatureUrl('/documents')"
          matTooltip="Save time managing your documents with AdvanceCM."
          matTooltipPosition="right"
          class="d-flex flex-column align-items-center"
        >
          <img src="/assets/images/icons/documents.svg" alt="" width="20" />
          Documents
          <span class="acm-new-badge"><i class="fas fa-sparkles"></i></span>
        </a>
      </li>
      <li class="acm-feature-item" *ngIf="!isOwner">
        <a
          [href]="acmFeatureUrl('/inventories')"
          matTooltip="Manage your property inventories with AdvanceCM."
          matTooltipPosition="right"
          class="d-flex flex-column align-items-center"
        >
          <img src="/assets/images/icons/inventories.svg" alt="" width="20" />
          Inventories
          <span class="acm-new-badge"><i class="fas fa-sparkles"></i></span>
        </a>
      </li>
      <li class="acm-feature-item" *ngIf="!isOwner">
        <a
          [href]="acmFeatureUrl('/automations')"
          matTooltip="Automate your property management with AdvanceCM Autopilot."
          matTooltipPosition="right"
        >
          <span class="icon fal fa-magic"></span>
          AutoPilot
          <span class="acm-new-badge"><i class="fas fa-sparkles"></i></span>
        </a>
      </li>
      <li class="acm-feature-item" *ngIf="!isOwner">
        <a
          [href]="acmFeatureUrl('/vendors')"
          matTooltip="Manage your property vendors with AdvanceCM"
          matTooltipPosition="right"
          class="d-flex flex-column align-items-center"
        >
          <img src="/assets/images/icons/vendors.svg" alt="" width="20" />
          Vendors
          <span class="acm-new-badge"><i class="fas fa-sparkles"></i></span>
        </a>
      </li>
      <li *ngxPermissionsOnly="['canSeeExpenses']" routerLinkActive="active">
        <a routerLink="/expenses">
          <span class="icon fal fa-briefcase"></span>
          Expenses
        </a>
      </li>
      <li *ngxPermissionsOnly="['canSeeTasks']" routerLinkActive="active">
        <a routerLink="/tasks/all">
          <span class="icon fal fa-tasks"></span>
          Tasks
        </a>
      </li>
      <li *ngxPermissionsOnly="['canSeeReviews']" routerLinkActive="active">
        <a routerLink="/reviews">
          <span class="icon fal fa-comments-alt"></span>
          Reviews
        </a>
      </li>
      <li *ngxPermissionsOnly="['canSeeReports']">
        <a [href]="reportsUrl()" target="_blank">
          <span class="icon fal fa-chart-line"></span>
          Reports
        </a>
      </li>
    </ul>
  </div>
</div>
